module.exports = __webpack_public_path__ + "static/media/right-arrow.dcab0254.svg";